/*
*  Product catalogue - word for word from the Wix site's product pop-ups (names, pack sizes & order kept as-is).
*  To add a product: drop a square image (~500px, transparent PNG works best) in public/images/products/<category>/
*  and add a line to that category's list below.
*/

export const PRODUCT_CATEGORIES = [
  {
    slug: "nuts",
    title: "Nuts",
    image: "/images/products/categories/nuts.png",
    products: [
      { name: "Almond Diced", sizes: "100g | 500g", image: "/images/products/nuts/almond-diced.png" },
      { name: "Almond Flaked", sizes: "100g | 500g | 1kg", image: "/images/products/nuts/almond-flaked.jpg" },
      { name: "Almonds Ground", sizes: "100g | 500g", image: "/images/products/nuts/almonds-ground.png" },
      { name: "Almonds Plain", sizes: "100g | 500g | 1kg", image: "/images/products/nuts/almonds-plain.png" },
      { name: "Almonds Slivered", sizes: "100g", image: "/images/products/nuts/almonds-slivered.png" },
      { name: "Brazil Nuts", sizes: "100g | 500g | 1kg", image: "/images/products/nuts/brazil-nuts.png" },
      { name: "Cashew Raw", sizes: "100g | 500g | 1kg", image: "/images/products/nuts/cashew-raw.jpg" },
      { name: "Cashew Salted", sizes: "100g | 500g | 1kg", image: "/images/products/nuts/cashew-salted.jpg" },
      { name: "Jumbo Peanuts", sizes: "200g | 500g | 1kg", image: "/images/products/nuts/jumbo-peanuts.png" },
      { name: "Macadamia Raw", sizes: "100g | 500g | 1kg", image: "/images/products/nuts/macadamia-raw.png" },
      { name: "Mixed Nuts Roasted & Salted", sizes: "100g | 500g | 1kg", image: "/images/products/nuts/mixed-nuts-roasted-and-salted.png" },
      { name: "Hazlenuts", sizes: "100g | 500g | 1kg", image: "/images/products/nuts/hazlenuts.png" },
      { name: "Macadamia Salted", sizes: "100g | 500g | 1kg", image: "/images/products/nuts/macadamia-salted.png" },
      { name: "Monkey Nuts", sizes: "500g", image: "/images/products/nuts/monkey-nuts.png" },
      { name: "Peanuts Roasted & Salted", sizes: "150g", image: "/images/products/nuts/peanuts-roasted-and-salted.png" },
      { name: "Peanuts Raw", sizes: "150g | 500g | 1kg", image: "/images/products/nuts/peanuts-raw.png" },
      { name: "Walnuts", sizes: "100g | 500g | 1kg", image: "/images/products/nuts/walnuts.png" },
      { name: "Pecan Nuts", sizes: "75g | 500g | 1kg", image: "/images/products/nuts/pecan-nuts.png" },
      { name: "Pine Kernels", sizes: "55g", image: "/images/products/nuts/pine-kernels.png" },
      { name: "Pistachio Kernels", sizes: "100g", image: "/images/products/nuts/pistachio-kernels.png" },
      { name: "Pistachio", sizes: "100g | 500g | 1kg", image: "/images/products/nuts/pistachio.png" },
      { name: "Pecan Nut Broken", sizes: "1kg", image: "/images/products/nuts/pistachio.png" },
      { name: "Pistachio White", sizes: "100g | 500g | 1kg", image: "/images/products/nuts/pistachio-white.png" },
      { name: "Pistachio Salted", sizes: "100g | 500g | 1kg", image: "/images/products/nuts/pistachio-salted.jpg" },
      { name: "Cashew Split Raw", sizes: "1kg", image: "/images/products/nuts/pistachio.png" },
    ],
  },
  {
    slug: "mixes",
    title: "Mixes",
    image: "/images/products/categories/mixes.png",
    products: [
      { name: "Mixed Nuts Plain", sizes: "100g | 500g | 1kg", image: "/images/products/mixes/mixed-nuts-plain.png" },
      { name: "Peanut & Raisins", sizes: "150g | 200g | 500g | 1kg", image: "/images/products/mixes/peanut-and-raisins.png" },
    ],
  },
  {
    slug: "dried-fruit",
    title: "Dried Fruit",
    image: "/images/products/categories/dried-fruit.png",
    products: [
      { name: "Fruit Cubes", sizes: "150g | 500g | 1kg", image: "/images/products/dried-fruit/fruit-cubes.png" },
      { name: "Fruit Mix", sizes: "150g | 500g", image: "/images/products/dried-fruit/fruit-mix.png" },
      { name: "Fruit Sticks", sizes: "150g | 500g | 1kg", image: "/images/products/dried-fruit/fruit-sticks.png" },
      { name: "Apricots", sizes: "150g | 500g | 1kg", image: "/images/products/dried-fruit/apricots.jpg" },
      { name: "Banana Chip", sizes: "150g | 250g", image: "/images/products/dried-fruit/banana-chip.jpg" },
      { name: "Figs", sizes: "150g | 500g | 1kg", image: "/images/products/dried-fruit/figs.png" },
      { name: "Prunes", sizes: "150g | 500g | 1kg", image: "/images/products/dried-fruit/prunes.png" },
      { name: "Raisins", sizes: "150g | 500g | 1kg", image: "/images/products/dried-fruit/raisins.jpg" },
      { name: "Pitless Dates", sizes: "150g | 500g | 1kg", image: "/images/products/dried-fruit/pitless-dates.png" },
      { name: "Cranberries", sizes: "150g | 500g | 1kg", image: "/images/products/dried-fruit/cranberries.jpg" },
      { name: "Peaches Cling", sizes: "150g | 500g | 1kg", image: "/images/products/dried-fruit/peaches-cling.jpg" },
      { name: "Goji Berries", sizes: "100g | 500g | 1kg", image: "/images/products/dried-fruit/goji-berries.png" },
      { name: "Mixed Berries", sizes: "150g | 500g | 1kg", image: "/images/products/dried-fruit/mixed-berries.png" },
      { name: "Coconut Flakes", sizes: "100g | 500g", image: "/images/products/dried-fruit/coconut-flakes.jpg" },
      { name: "Hawaiian Mix", sizes: "150g | 500g | 1kg", image: "/images/products/dried-fruit/hawaiian-mix.jpg" },
      { name: "Jungle Mix", sizes: "150g | 500g | 1kg", image: "/images/products/dried-fruit/jungle-mix.jpg" },
    ],
  },
  {
    slug: "sweet-snacks",
    title: "Sweet Snacks",
    image: "/images/products/categories/sweet-snacks.png",
    products: [
      { name: "Pineapple Cubes", sizes: "500g", image: "/images/products/sweet-snacks/pineapple-cubes.png" },
      { name: "Choc Sunflower", sizes: "100g | 150g | 500g", image: "/images/products/sweet-snacks/choc-sunflower.jpg" },
      { name: "Pink & White Peanuts", sizes: "200g | 500g", image: "/images/products/sweet-snacks/pink-and-white-peanuts.png" },
      { name: "Pink & White Almonds", sizes: "200g | 500g", image: "/images/products/sweet-snacks/pink-and-white-almonds.jpg" },
      { name: "Peanut Caramel", sizes: "200g | 500g", image: "/images/products/sweet-snacks/peanut-caramel.jpg" },
      { name: "Cashew Caramel", sizes: "75g", image: "/images/products/sweet-snacks/cashew-caramel.png" },
      { name: "Almond Caramel", sizes: "75g", image: "/images/products/sweet-snacks/almond-caramel.png" },
      { name: "Mixed Nut Caramel", sizes: "75g", image: "/images/products/sweet-snacks/mixed-nut-caramel.jpg" },
      { name: "Coconut Brittle", sizes: "200g", image: "/images/products/sweet-snacks/coconut-brittle.png" },
      { name: "Peanut Brittle", sizes: "250g", image: "/images/products/sweet-snacks/peanut-brittle.png" },
      { name: "Cashew Brittle", sizes: "200g", image: "/images/products/sweet-snacks/cashew-brittle.png" },
      { name: "Sesame Seed Brittle", sizes: "200g", image: "/images/products/sweet-snacks/sesame-seed-brittle.png" },
      { name: "Almond Bar", sizes: "30 x 50g", image: "/images/products/sweet-snacks/almond-bar.png" },
      { name: "Mixed Seed Bar", sizes: "30 x 50g", image: "/images/products/sweet-snacks/mixed-seed-bar.png" },
      { name: "Fruit & Nut Brittle Bar", sizes: "30 x 50g", image: "/images/products/sweet-snacks/fruit-and-nut-brittle-bar.png" },
      { name: "Peanut Brittle Bar", sizes: "30 x 50g", image: "/images/products/sweet-snacks/peanut-brittle-bar.jpg" },
      { name: "Cashew Brittle Bar", sizes: "30 x 50g", image: "/images/products/sweet-snacks/cashew-brittle-bar.png" },
      { name: "Cashew Bar", sizes: "30 x 50g", image: "/images/products/sweet-snacks/cashew-bar.png" },
      { name: "Sesame Seed Bar", sizes: "30 x 50g", image: "/images/products/sweet-snacks/sesame-seed-bar.png" },
      { name: "Seed & Nut Bar", sizes: "30 x 50g", image: "/images/products/sweet-snacks/seed-and-nut-bar.png" },
      { name: "Mixed Nut Bar", sizes: "30 x 50g", image: "/images/products/sweet-snacks/mixed-nut-bar.jpg" },
      { name: "Mixed Nuts Cara", sizes: "100g", image: "/images/products/sweet-snacks/cashew-bar.png" },
    ],
  },
  {
    slug: "savoury-snacks",
    title: "Savoury Snacks",
    image: "/images/products/categories/savoury-snacks.png",
    products: [
      { name: "Super Snack", sizes: "75g", image: "/images/products/savoury-snacks/super-snack.jpg" },
      { name: "Spicy Corn", sizes: "150g | 250g | 500g | 1kg", image: "/images/products/savoury-snacks/spicy-corn.png" },
      { name: "Japanese Mix", sizes: "100g | 200g", image: "/images/products/savoury-snacks/japanese-mix.png" },
      { name: "Spicy Snack", sizes: "75g | 150g | 500g", image: "/images/products/savoury-snacks/spicy-snack.png" },
      { name: "Jumbo Corn Chilli", sizes: "150g", image: "/images/products/savoury-snacks/jumbo-corn-chilli.png" },
      { name: "Jumbo Corn Salted", sizes: "150g", image: "/images/products/savoury-snacks/jumbo-corn-salted.png" },
      { name: "Jumbo Corn BBQ", sizes: "150g", image: "/images/products/savoury-snacks/jumbo-corn-bbq.png" },
      { name: "Cashew Peri-Peri", sizes: "150g", image: "/images/products/savoury-snacks/cashew-peri-peri.png" },
      { name: "Wasabi Peanuts", sizes: "250g", image: "/images/products/savoury-snacks/wasabi-peanuts.jpg" },
    ],
  },
  {
    slug: "seeds",
    title: "Seeds",
    image: "/images/products/categories/seeds.png",
    products: [
      { name: "Pumpkin Seeds Green", sizes: "150g | 500g | 1kg", image: "/images/products/seeds/pumpkin-seeds-green.png" },
      { name: "Mixed Seed", sizes: "200g | 500g | 1kg", image: "/images/products/seeds/mixed-seed.png" },
      { name: "Sesame Seeds", sizes: "200g | 1kg", image: "/images/products/seeds/sesame-seeds.png" },
      { name: "Sunflower Seeds", sizes: "200g | 500g | 1kg", image: "/images/products/seeds/sunflower-seeds.png" },
    ],
  },
  {
    slug: "aloe-vera-water",
    title: "Aloe Vera Water",
    image: "/images/products/categories/aloe-vera-water.png",
    intro: "Almans is the sole importer of T-Best Aloe Vera Water. This can be found in most supermarkets in South Africa. We have a wide variety of flavours that come in sugar-free and original flavours. Our Aloe can be enjoyed in a 1.5 litre or 500 ml bottle.",
    products: [
      { name: "Aloe Original", note: "Sugar Free", sizes: "500ml", image: "/images/products/aloe-vera-water/aloe-original-500ml.png" },
      { name: "Aloe Pomegranate", note: "Sugar Free", sizes: "500ml", image: "/images/products/aloe-vera-water/aloe-pomegranate-500ml.png" },
      { name: "Aloe Litchi", note: "Sugar Free", sizes: "500ml", image: "/images/products/aloe-vera-water/aloe-litchi-500ml.png" },
      { name: "Aloe Strawberry", note: "Sugar Free", sizes: "500ml", image: "/images/products/aloe-vera-water/aloe-strawberry-500ml.png" },
      { name: "Aloe Original", note: "Sugar Free", sizes: "1.5L", image: "/images/products/aloe-vera-water/aloe-original-1-5l.jpg" },
      { name: "Aloe Pomegranate", note: "Sugar Free", sizes: "1.5L", image: "/images/products/aloe-vera-water/aloe-pomegranate-1-5l.jpg" },
      { name: "Aloe Pineapple", note: "Sugar Free", sizes: "1.5L", image: "/images/products/aloe-vera-water/aloe-pineapple-1-5l.jpg" },
    ],
  },
];
